import { Injectable } from '@angular/core';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';
import {IRiderPayorBillingDefault} from '../../core/interfaces/rider-payor.interface';

@Injectable()
export class RiderService extends ParentService {
    smartTableData = [];

    constructor(private _http: Http, private route: Router) {
        super();
        // this.verifyToken(this._http, route);
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    addHistoryFile(data) {
        const bodyString = JSON.stringify(data);
        return this._http.put(constant.URL_ADD_RIDER_HISTORY, bodyString, this.headerPost())
            .map((res: Response ) => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param {number} id
     * @returns {Observable<any>}
     */
    getRiderHistory(id:number) {
        const url = constant.URL_GET_RIDER_HISTORY + id;

        return this._http.get(url, this.getHeader()).map(
            res => res.json()
        );
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    resendPassword(data: any) {
        const bodyString = JSON.stringify(data);
        return this._http.put(constant.URL_REMEMBER_PASSWORD, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param {number} id
     * @returns {Observable<any>}
     */
  getRider(id: number, inactive: boolean) {
    const url = `${constant.URL_RIDER}/${id}?includeInactive=${inactive}`;
    return this._http.get(url, this.getHeader())
      .map(res => res.json());
  }

  /**
   *
   * @param id
   */
  getRiderPayorDetail(id: number) {
        const url = constant.URL_RIDER_PAYOR_DETAIL + '/' + id;

        return this._http.get(url,this.getHeader()).map(
            res => res.json());

    }

    /**
     * @description
     * @param {string} method
     */
    getArray(method: string) {
        this.getRiders(method).
        subscribe(
            data => {
                this.smartTableData = data;
            }
        );
    }

    /**
     * @description
     * @param {string} param
     * @returns {Observable<any>}
     */
    getRiders(param: string) {
        if ( param === null ) {
          return this._http.get(constant.URL_RIDER, this.getHeader()).map(res => res.json());
        }else {
            return this._http.get(constant.URL_RIDER + '?term=' + param, this.getHeader()).map( res => res.json());
        }
    }

    /**
     * @description
     * @param {string} method
     * @returns {Promise<any>}
     */
    getData(method: string): Promise<any> {
        this.getArray(method);
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(this.smartTableData);
            }, 2000);
        });
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    postData(data: any) {
        const bodyString = JSON.stringify(data);
        const headers = new Headers({'Content-Type': 'application/json', 'Version': this.localVersion});
        const options = new RequestOptions({headers: headers});

        return this._http.post(constant.URL_RIDER, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    putData(data: any) {
        delete data.addedon;
        delete data.modifiedon;
        const bodyString = JSON.stringify(data);
        return this._http.put(constant.URL_RIDER, bodyString, this.headerPost())
            .map((res: Response ) => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param data
     */
    deleteData(data: any) {

    }

    /**
     * @description
     * @param {number} riderId
     * @returns {Observable<any>}
     */
    getRiderPayor(riderId: number) {
        return this._http.get(constant.URL_RIDER_PAYOR + riderId, this.getHeader())
            .map(res => res.json());
    }

    /**
     * @description
     * @param {number} riderId
     * @returns {Observable<any>}
     */
    getPayorByRider(riderId: number, dateOfService: string = null) {
        return this._http.get(constant.URL_GET_RIDER_PAYORS + riderId + '&dateOfService=' + dateOfService, this.getHeader())
            .map(res => res.json());
    }

    /**
     * @description
     * @param location
     * @returns {Observable<any>}
     */
    getGeoCode(location: any) {
        return this._http.get(constant.URL_TRIP_LOCATION + location, this.getHeader())
            .map( res => res.json());
    }

    /**
     * @description
     * @param {number} riderId
     * @param showCancel
     * @param showClosed
     * @param futureTips
     * @param page
     * @param pageSize
     * @returns {Observable<any>}
     */
    getTripsRider(riderId: number, showCancel, showClosed, futureTips, page, pageSize) {
        return this._http.get(constant.URL_TRIP_HISTORY_RIDER + riderId + '/' + showCancel + '/'
            + showClosed + '/' + futureTips + '/' + page + '/' + pageSize, this.getHeader()).map(res => res.json());
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    getTripsListByRider(data) {
        const bodyString = JSON.stringify(data);
        return this._http.post(constant.URL_TRIP_LIST_BY_RIDER, bodyString, this.headerPost())
            .map(res => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param {number} riderId
     * @returns {Observable<any>}
     */
    getStandingOrder(riderId: number) {
        return this._http.get(constant.URL_TRIP_STANDING_ORDER_BY_RIDER + riderId, this.getHeader())
            .map(res => res.json());
    }

    /**
     * @description
     * @param {number} standingORderId
     * @returns {Observable<any>}
     */
    getStandingOrderById(standingORderId:number) {
        return this._http.get(constant.URL_TRIP_STANDING_ORDER_BY_ID + standingORderId, this.getHeader())
            .map(res => res.json());
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    advanceSearch(data) {
        return this._http.post(constant.URL_SEARCH, data, this.headerPost())
            .map((res: Response ) => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    advanceSearchByClaim(claimNUmber) {
      return this._http.get(constant.URL_ADVANCE_SEARCH_BY_CLAIM + '/' + claimNUmber, this.getHeader())
        .map(res => res.json())
        .catch((error: any ) => Observable.throw(error.json()));
    }
  /**
   * @description retorna los payor del rider con el billing schedule default
   * @param {number} riderId
   * @param {number} brokerid
   * @returns {Observable<IRiderPayorBillingDefault[]>}
   */
  public getPayorAndBillingByRider(riderId: number, brokerid: number): Observable<IRiderPayorBillingDefault[]> {
    return this._http.get(`${constant.URL_BILLING_SCHEDULE_PAYORS}${riderId}&brokerid=${brokerid}`, this.getHeader())
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/riders/rider.service.ts